import React from "react";
import ConnectPlaceholder from "./ConnectPlaceholder";

const MentorshipRequest = () => (
  <ConnectPlaceholder
    title="Mentorship - Request Mentorship"
    intro="Submit a mentorship request and outline the support you are looking for."
  />
);

export default MentorshipRequest;


